import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SearchField from '../../../../../../../../../components/SearchField/SearchField';
import useHousingStockMatch from '../../../../../../../hooks/useHousingStockMatch';
import { placeholders } from '../../constants';
import {
  flatsViewSelector,
  searchSelector,
  getMode,
  searchChangeCb,
} from '../../utils';
import { flatsViews } from '../../../../../../../constants/flatsViews';
import { setSearchFieldValue } from '../../../../../../../store/actions/housingStockActions';
import { links } from '../../../../../../../constants/links';
import styles from './Search.module.scss';

const houseTabs = links.house.pages;

const Search = () => {
  const dispatch = useDispatch();
  const match = useHousingStockMatch();
  const { page, pageTab, pageTabId } = match?.params || {};

  const flatsView = useSelector(flatsViewSelector);
  const search = useSelector(searchSelector);

  const mode = getMode({
    page,
    pageTab,
    isFlatsTableView: flatsView === flatsViews.table,
  });

  const hideSearch =
    pageTab === houseTabs.info ||
    pageTab === houseTabs.meters ||
    (pageTab === houseTabs.flats &&
      (pageTabId || flatsView === flatsViews.grid));

  const handleChange = (e) => {
    dispatch(setSearchFieldValue({ [mode]: e.target.value }));
    searchChangeCb(mode, dispatch);
  };

  return (
    !hideSearch && (
      <SearchField
        value={search[mode]}
        onChange={handleChange}
        className={styles.root}
        placeholder={placeholders[mode]}
      />
    )
  );
};

export default Search;
